import type { ReactionBody } from '../model/types'

import { $messages, updateMessage } from '../model/stores'

function updateReactions({
	emoji,
	mark,
	message
}: Omit<ReactionBody, 'conversation'>) {
	const messages = $messages.get()

	if (!messages[message]) {
		return null
	}

	const { reaction_summaries: olds } = messages[message]

	const found = olds.findIndex(reaction => reaction.emoji === emoji)

	const patch = [...olds]

	const shouldAddNewOne = mark && found === -1

	if (shouldAddNewOne) {
		patch.push({
			count: 1,
			emoji,
			viewerReacted: true
		})
	} else {
		const exist = found !== -1
		if (exist) {
			const newOne = { ...olds[found] }
			const shouldRemove = !mark && newOne.count < 2

			if (shouldRemove) {
				patch.splice(found, 1)
			} else {
				newOne.count += mark ? 1 : -1
				newOne.viewerReacted = mark

				patch[found] = newOne
			}
		}
	}

	updateMessage(message, { reaction_summaries: patch })

	return () => updateMessage(message, { reaction_summaries: olds })
}

export { updateReactions }
